import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13 3a1 1 0 1 0-2 0v15.586l-7.293-7.293a1 1 0 0 0-1.414 1.414l9 9a1 1 0 0 0 1.414 0l9-9a1 1 0 0 0-1.414-1.414L13 18.586z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }